export function initDevSiteLanding() {
    if (!$('#dev_site_landing').length) return;

    var acc = document.getElementsByClassName("opening-button");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                panel.style.marginBottom = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                panel.style.marginBottom = "26px";
            }
        });
    }

}


